<template>
  <div class="prologue-intro container">
    <div class="bottom-set">
      <div class="explain-box">
        <div class="arrowSet">
          <img
            :src="arrowLeft"
            :class="{ 'arrow-hidden': currentSlide === 1 }"
            class="arrow"
            @click="handleLeftClick"
          />
          <div
            align="center"
            class="headline is-text-bold is-uppercase is-size-medium"
          >
            {{ $t("prologue.intro.headline") }}
          </div>
          <img
            :src="arrowRight"
            :class="{ 'arrow-hidden': currentSlide === 3 }"
            class="arrow"
            @click="handleRightClick"
          />
        </div>
        <div class="rules">
          <div class="slide slide-1" v-if="currentSlide === 1">
            <div class="left">
              <img src="@/assets/images/icon-mobile-phone.svg" />
            </div>
            <div class="right">
              {{ $t("prologue.intro.slide_1") }}
            </div>
          </div>
          <div class="slide slide-2" v-if="currentSlide === 2">
            <div class="left">
              <img src="@/assets/images/icon-fight.svg" />
            </div>
            <div class="right">
              {{ $t("prologue.intro.slide_2") }}
            </div>
          </div>
          <div class="slide slide-3" v-if="currentSlide === 3">
            <div class="left">
              <img src="@/assets/images/icon-shots.svg" />
            </div>
            <div class="right">
              {{ $t("prologue.intro.slide_3") }}
            </div>
          </div>
        </div>
        <div class="button" v-if="currentSlide === 3" @click="goToChooseName()">
          {{ $t("prologue.intro.cta") }}
        </div>
        <div class="button" v-else @click="currentSlide += 1">
          {{ $t("prologue.intro.next") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import arrowLeft from "@/assets/images/icon-arrow-left-opt.svg";
import arrowRight from "@/assets/images/icon-arrow-right-opt.svg";
import { useGameTracking } from "@/composables/useGameTracking";

export default {
  data() {
    return {
      currentSlide: 1,
      arrowLeft,
      arrowRight,
    };
  },
  methods: {
    async goToChooseName() {
      this.clickSound.play();
      
      // Track step change to chooseName
      const { kpiTracker, session } = useGameTracking();
      try {
        await session.updateSessionProgress(kpiTracker.getKpiData(), {
          step: "chooseName",
        });
      } catch (error) {
        console.error("Error updating session for chooseName step:", error);
      }
      
      this.currentStep = "chooseName";
    },
    handleLeftClick() {
      if (this.currentSlide > 1) {
        this.currentSlide -= 1;
      }
    },
    handleRightClick() {
      if (this.currentSlide < 3) {
        this.currentSlide += 1;
      }
    },
  },
  watch: {
    currentSlide() {
      this.swipeSound.play();
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/assets/sass/abstracts/variables"
.prologue-intro
  z-index: 10

.headline
  margin-bottom: 2rem

.rules
  border-top: 2px solid $color-white
  padding: 2rem 0
  font-size: 1.7
  line-height: 1.3

.slide
  display: grid
  grid-template-columns: minmax(7rem, 23%) 1fr

  .left img
    width: 7rem

  .right
    height: 9rem
    padding-right: 1.5rem

.explain-box
  color: $color-white

.arrowSet
  display: flex
  justify-content: space-between
  flex-direction: row

.arrow
  width: 3.5rem
  margin: 0 1rem
  margin-bottom: 2rem

.arrow-hidden
  visibility: hidden
</style>
